// extracted by mini-css-extract-plugin
export default {"sr-only":"_og44Q","skeleton-line":"Ml_3L2","shine":"VeU9Se","scroll-hidden":"BUu18j","title":"N2CQZJ","tabs":"L8y5D7"};